<script lang="ts" setup>
import { computed } from "vue";
import { formatThousandNoFraction } from "@/composables/formatNumbers";

const props = defineProps({
  tableData: {
    type: Object,
  },
});

const headers = [
  { title: "Label", key: "name" },
  { title: "Aantal", key: "value", align: "end" },
];

const expireData = computed(() => {
  console.log("props.tableData: ", props.tableData.sevenYears);
  return [
    { name: "0 t/m 3 jaar", key: props.tableData.zeroToFourYears },
    { name: "4 t/m 6 jaar", key: props.tableData.fourToSevenYears },
    { name: "7 jaar", key: props.tableData.sevenYears },
    { name: "8 jaar", key: props.tableData.eightYears },
    { name: "9 jaar", key: props.tableData.nineYears },
    { name: "Verlopen", key: props.tableData.expired },
    { name: "Geen label", key: props.tableData.noLabel },
  ];
});
</script>

<template>
  <v-data-table density="compact" :headers="headers" hide-default-footer :items="expireData" disable-sort class="overview-table">
    <template v-slot:[`item.value`]="{ item }">
      <span v-if="item.key >= 1">{{ formatThousandNoFraction(item.key) }}</span>
      <span v-else>-</span>
    </template>
  </v-data-table>
</template>
